// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__kVoO_","label":"Section_label__2BLaT","contentWrap":"Section_contentWrap__PMcgv","footer":"Section_footer__29yKQ","footerInner":"Section_footerInner__syrHt"};